<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTitle } from '@vueuse/core';

useTitle('Помилка сервера');

const route = useRoute();

const customMessage = computed(() => route.query.message as string | undefined);

const error = computed(() => ({
  statusCode: 500,
  statusMessage: 'Помилка сервера',
  message: customMessage.value || 'Щось пішло не так. Спробуйте ще раз пізніше.',
}));
</script>

<template>
  <UError
    :error="error"
    :clear="false"
  >
    <template #links>
      <RouterLink :to="{ name: 'Home' }">
        <UButton
          size="lg"
          color="primary"
          label="На головну"
        />
      </RouterLink>
    </template>
  </UError>
</template>
